import { Hash } from 'lucide-react';

import { Table, type TableColumn } from '@/_shared/components/Table';
import { Callout } from '@/_shared/components/ui/callout';
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@/_shared/components/ui/empty';

import { SlackTableSkeleton } from './SlackSkeletons';
import { type SlackChannelBinding, SUBSECTION_HEADING } from './types';

interface SlackConnectedChannelsSectionProps {
  count: number;
  bindings: SlackChannelBinding[];
  columns: TableColumn<SlackChannelBinding>[];
  isLoading: boolean;
  isError: boolean;
}

export function SlackConnectedChannelsSection({
  count,
  bindings,
  columns,
  isLoading,
  isError,
}: SlackConnectedChannelsSectionProps): React.ReactElement {
  return (
    <div>
      <h3 className={`mb-2 ${SUBSECTION_HEADING}`}>
        Connected channels{count > 0 && <span className="ml-1.5 text-muted-foreground/50">{count}</span>}
      </h3>
      {isLoading ? (
        <SlackTableSkeleton rows={2} />
      ) : isError ? (
        <Callout variant="error">Failed to load connected channels.</Callout>
      ) : bindings.length === 0 ? (
        <Empty className="border">
          <EmptyHeader>
            <EmptyMedia variant="icon">
              <Hash />
            </EmptyMedia>
            <EmptyTitle>No connected channels yet</EmptyTitle>
            <EmptyDescription>
              Run <code>/lookout setup</code> in a Slack channel to connect it to this workspace.
            </EmptyDescription>
          </EmptyHeader>
        </Empty>
      ) : (
        <Table
          data={bindings}
          columns={columns}
          getRowId={(binding) => `${binding.teamId}-${binding.channelId}`}
          fixedLayout
          maxHeight="24rem"
        />
      )}
    </div>
  );
}
